import {pushEdapEvent} from './../../utils/edap';

export const ACTION_LOCATION = 'dynamic-refinements-component';
export const EVENT_CATEGORY = 'link-click';

export const handleClick = (props) => {
    const {lbsId, position, filterId} = props;

    const fastPathEventOptions = {
        action_location: ACTION_LOCATION,
        event_lbsuuid: lbsId,
        event_category: EVENT_CATEGORY,
        event_refinements: [`position:${position}`, `filter:${filterId}`].join(
            ','
        ),
    };

    return () => {
        pushEdapEvent('content_tile.selected', fastPathEventOptions);
    };
};
